export default __webpack_public_path__ + "static/bulbs2-c2d55665bc5c74b65f7c8eb533d0eb12.mp4";